/* global jQuery MktoForms2 */
jQuery(document).ready(function ($) {
    $(".q-accordion button").click(function(){
        var $answer = $(this).closest(".q-accordion").next(".q-answer");
        $answer.toggleClass("hidden open");

        // Toggle the visibility of the SVG icons
		$(this).find("svg").toggle();
    });
});

(function ($, MktoForms2) {

	"use strict";

	MktoForms2.onFormRender(function () {
		setTimeout(function(){
			$(".mktoButtonWrap button[type=submit]").text("Get a Demo");
		}, 5);
	});
}(jQuery, MktoForms2));

document.addEventListener("DOMContentLoaded", function() {
	const getDemoButton = document.getElementById("get-demo-button");
	const heroSection = document.getElementById("request-demo");
  
	window.addEventListener("scroll", function() {
	  const heroBottom = heroSection.getBoundingClientRect().bottom;
	  if (heroBottom < 0) {
		getDemoButton.classList.add("visible");
	  } else {
		getDemoButton.classList.remove("visible");
	  }
	});
  
	getDemoButton.addEventListener("click", function() {
	  window.scrollTo({ top: 0, behavior: "smooth" });
	});
  });